import React from 'react';
import { Link } from 'react-router-dom';
import StoreLayout from './StoreLayout';
import SearchBox from './SearchBox';
import { useCategories } from './catalogApi';
import { categoryLink, useDocumentTitle } from './retailUtils';

/** Phone search screen: the search box up top with instant suggestions, plus category shortcuts. */
export default function StoreSearchPage() {
  const categories = useCategories().slice(0, 12).map(c => c.name);
  useDocumentTitle('Search');

  return (
    <StoreLayout narrow>
      <div className="rt-search-page"><SearchBox autoFocus /></div>
      {categories.length > 0 && (
        <>
          <h2 className="rt-section-title" style={{ marginTop: 24 }}>Browse categories</h2>
          <div className="rt-pills" style={{ flexWrap: 'wrap' }}>
            {categories.map(c => <Link key={c} to={categoryLink(c)} className="rt-pill">{c}</Link>)}
          </div>
        </>
      )}
    </StoreLayout>
  );
}
